import React, { useEffect, useState } from "react";
import ImageUrlBuilder from "@sanity/image-url";
import BlogPost from "../components/blogdetails/BlogPost";
import BlogDetBread from "../components/blogdetails/BlogDetBread";
import { getSanityClient } from "../sanintyClient";
import { useParams } from "react-router-dom";

const client = getSanityClient();
const { projectId, dataset } = client.config();
const postImage = (source) =>
  projectId && dataset
    ? ImageUrlBuilder({ projectId, dataset }).image(source)
    : null;

function BlogDetailsPage() {
  const [postData, setPostData] = useState(null);
  const [categories, setCategories] = useState(null);
  const [allPosts, setAllPosts] = useState(null);

  const { id } = useParams(); // Obtener el id de la URL

  useEffect(() => {
    client
      .fetch(
        `*[_type == "categories"]{
            _id, 
            title, 
          }`
      )
      .then((data) => setCategories(data))
      .catch((err) => console.error(err));

    client
      .fetch(
        `*[_type == "blogPost"]{ _id, title, content, slug, author, publishedAt, mainImage, categories, excerpt }`
      )
      .then((data) => setAllPosts(data))
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "blogPost" && _id == $id]{
          _id, title, content, slug, author, publishedAt, mainImage, excerpt, categories[]-> {
            _id, 
            title
          }
        }`,
        { id }
      )
      .then((data) => setPostData(data[0])) // Suponemos que solo hay un post que coincide con el id
      .catch((err) => console.error(err));
  }, [id]);

  useEffect(() => {
    console.log(postData); // Puedes ver el postData en consola
  }, [postData]);

  if (!postData) return <p>Cargando...</p>;

  return (
    <main>
      <BlogDetBread post={postData} />
      <BlogPost
        post={postData}
        postImage={postImage}
        allCategories={categories}
        allPosts={allPosts}
      />
    </main>
  );
}

export default BlogDetailsPage;
